import React from 'react';

function AlreadyExistsContainer({ labels, participant_data }) {
    return (
        <p>
            <h3>{participant_data.nicename}</h3>
            {participant_data.text_1}<br />
            {participant_data.text_2}<br />
            <a href={participant_data.email_link}>{participant_data.email_text}</a> ( {participant_data.email_text} )
        </p>
    );
}

export default AlreadyExistsContainer;